<div class="icon-label-container">
  <div
    class="icon-container"
    [ngClass]="{
        'color-type1': color=='type1', 
        'color-type2': color=='type2', 
        'color-type3': color=='type3', 
        'color-type4': color=='type4'
    }">
    <mat-icon class="icon">{{icon}}</mat-icon>
  </div>
  <!-- <span class="il-flex-spacer"></span> -->
  <div class="label-container">
    <div class="il-label">{{label}}</div>
    <div class="il-sublabel">{{sublabel}}</div>
  </div>

</div>
